import * as vp from 'vopay';
import { useState } from 'react';
import vopayApi from '@/services/api.config';

type HookProps = {
  api: vp.Api;
  bearer?: string;
};

function useVoidCreditCardTransaction({ api, bearer }: HookProps) {
  const [loading, setLoading] = useState(false);

  async function voidCreditCardTransaction(params: vp.VoidCreditCardTransactionRequest) {
    try {
      setLoading(true);
      const res = await api.voidCreditCardTransaction(params, bearer);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    voidCreditCardTransaction,
  };
}

export default vopayApi.withApiHook<HookProps, ReturnType<typeof useVoidCreditCardTransaction>>(useVoidCreditCardTransaction);
